/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CertificateBruger } from '../models/certificate-bruger';
@Injectable({
  providedIn: 'root',
})
class ProfilService extends __BaseService {
static readonly getPath = '/profil';
static readonly putPath = '/profil/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  private getResponse(): __Observable<__StrictHttpResponse<CertificateBruger>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/profil`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CertificateBruger>;
      })
    );
  }

  /**
   * @return Success
   */
  get(): __Observable<CertificateBruger> {
    return this.getResponse().pipe(
      __map(_r => _r.body as CertificateBruger)
    );
  }

  /**
   * @param params The `ProfilService.PutParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `profil`:
   *
   * @return Success
   */
  private putResponse(params: ProfilService.PutParams): __Observable<__StrictHttpResponse<CertificateBruger>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.profil;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/profil/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CertificateBruger>;
      })
    );
  }

  /**
   * @param params The `ProfilService.PutParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `profil`:
   *
   * @return Success
   */
  put(params: ProfilService.PutParams): __Observable<CertificateBruger> {
    return this.putResponse(params).pipe(
      __map(_r => _r.body as CertificateBruger)
    );
  }
}

module ProfilService {

  /**
   * Parameters for put
   */
  export interface PutParams {
    id: string;
    profil?: CertificateBruger;
  }
}

export { ProfilService }
